import Footer from "./Footer";

export default Footer;
export type { Navigation, SocialLink } from "./Footer";
